/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * OAuth2 configuration. Required when `authMethod` is `oauth2`.
 * @export
 * @interface SetCustomEmailSettingsRequestSettingsOauth2Auth
 */
export interface SetCustomEmailSettingsRequestSettingsOauth2Auth {
    /**
     * Azure AD tenant ID (for Microsoft 365 / Exchange Online).
     */
    tenantId?: string;
    /**
     * OAuth2 client/application ID.
     */
    clientId: string;
    /**
     * OAuth2 client secret.
     */
    clientSecret: string;
    /**
     * Token endpoint URL.
     */
    tokenUrl?: string;
    /**
     * OAuth2 scope(s) to request.
     */
    scope?: string;
    /**
     * Pre-fetched access token (optional; fetched automatically if omitted).
     */
    accessToken?: string;
}

/**
 * Check if a given object implements the SetCustomEmailSettingsRequestSettingsOauth2Auth interface.
 */
export function instanceOfSetCustomEmailSettingsRequestSettingsOauth2Auth(value: object): value is SetCustomEmailSettingsRequestSettingsOauth2Auth {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('clientSecret' in value) || value['clientSecret'] === undefined) return false;
    return true;
}

export function SetCustomEmailSettingsRequestSettingsOauth2AuthFromJSON(json: any): SetCustomEmailSettingsRequestSettingsOauth2Auth {
    return SetCustomEmailSettingsRequestSettingsOauth2AuthFromJSONTyped(json, false);
}

export function SetCustomEmailSettingsRequestSettingsOauth2AuthFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetCustomEmailSettingsRequestSettingsOauth2Auth {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'clientId': json['clientId'],
        'clientSecret': json['clientSecret'],
        'tokenUrl': json['tokenUrl'] == null ? undefined : json['tokenUrl'],
        'scope': json['scope'] == null ? undefined : json['scope'],
        'accessToken': json['accessToken'] == null ? undefined : json['accessToken'],
    };
}

export function SetCustomEmailSettingsRequestSettingsOauth2AuthToJSON(json: any): SetCustomEmailSettingsRequestSettingsOauth2Auth {
    return SetCustomEmailSettingsRequestSettingsOauth2AuthToJSONTyped(json, false);
}

export function SetCustomEmailSettingsRequestSettingsOauth2AuthToJSONTyped(value?: SetCustomEmailSettingsRequestSettingsOauth2Auth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'clientId': value['clientId'],
        'clientSecret': value['clientSecret'],
        'tokenUrl': value['tokenUrl'],
        'scope': value['scope'],
        'accessToken': value['accessToken'],
    };
}

